import React from 'react'

export default function Hero({ children, hero }) {
    return (
        /*
        So, the hero prop decides which images need to be rendered.
        By default, it renders the HOME image, otherwise it will be ROOM image
        depends on the room type.
        The children prop decides which text need to be rendered on the image.
        */
        <header className={hero}>
            {children}
        </header>
    )
}

Hero.defaultProps = {
    hero: "defaultHero"
};
